import { render, staticRenderFns } from "./inputType.vue?vue&type=template&id=63d08d3c"
import script from "./inputType.vue?vue&type=script&lang=js"
export * from "./inputType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports